var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashiconsWordpressAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 55,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M55.5 27.5C55.5 12.348 43.153 0 28 0 12.82 0 .5 12.348.5 27.5.5 42.68 12.82 55 28 55c15.153 0 27.5-12.32 27.5-27.5M21.895 42.267l-9.377-25.162a63 63 0 0 0 3.217-.22c1.375-.165 1.21-3.108-.165-3.053 0 0-3.988.303-6.517.303-.496 0-1.018 0-1.596-.027A24.39 24.39 0 0 1 28 3.053c6.407 0 12.237 2.392 16.638 6.435-1.87-.303-4.538 1.072-4.538 4.345 0 2.034 1.237 3.74 2.475 5.775.962 1.677 1.512 3.74 1.512 6.764 0 4.098-3.85 13.75-3.85 13.75l-8.332-23.017c1.485-.055 2.255-.468 2.255-.468 1.375-.137 1.21-3.437-.165-3.354 0 0-3.96.33-6.545.33-2.392 0-6.407-.33-6.407-.33-1.375-.083-1.54 3.3-.165 3.355l2.53.22 3.464 9.377zM48.377 27.5c.66-1.76 2.035-5.142 1.183-11.687 1.925 3.547 2.887 7.452 2.887 11.687 0 9.048-4.757 17.16-12.1 21.395 2.668-7.123 5.335-14.3 8.03-21.395M17.275 49.748C9.08 45.788 3.553 37.208 3.553 27.5c0-3.575.632-6.82 1.98-9.872 3.904 10.697 7.81 21.422 11.742 32.12m11.083-18.233 7.095 19.195A23.2 23.2 0 0 1 28 51.947c-2.172 0-4.317-.302-6.297-.907 2.227-6.545 4.454-13.035 6.655-19.525"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.5 0h55v55H.5z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashiconsWordpressAlt);
export default __webpack_public_path__ + "static/media/dashicons_wordpress-alt.28ad688c1f9a1ce44af371609d436e68.svg";
export { ForwardRef as ReactComponent };